import {Button} from "@zendeskgarden/react-buttons";
import {Body, Close, Footer, FooterItem, Header, Modal} from "@zendeskgarden/react-modals";
import {ReactElement} from "react";
import * as css from "../styles/narrativeEditor.module.scss";


interface UnsavedChangesModalProps {
    isSaving: boolean;
    onKeepEditing: () => void;
    onDiscard: () => void;
    onSave: () => void;
}

export default function UnsavedChangesModal(props: UnsavedChangesModalProps): ReactElement {
    return (
        <Modal onClose={props.isSaving ? undefined : props.onKeepEditing}>
            <Header>Unsaved Changes</Header>
            <Body>
                <p className={css.modalText}>
                    The section you're editing has unsaved changes. Do you want to save them first?
                </p>
            </Body>
            <Footer>
                <FooterItem>
                    <Button isBasic isDanger disabled={props.isSaving} onClick={props.onDiscard}>
                        Discard
                    </Button>
                </FooterItem>
                <FooterItem>
                    <Button isPrimary disabled={props.isSaving} onClick={props.onSave}>
                        Save
                    </Button>
                </FooterItem>
            </Footer>
            <Close aria-label="Close modal" />
        </Modal>
    );
}
